import { Col, Form, Row } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateField } from '../../../../../contextRedux/WorkPlace/WorkPlaceModel';
import { RootState } from '../../../../../store';

const TimeTableTab: React.FC = () => {
  const dispatch = useDispatch();

  const [form] = Form.useForm();

  const initialValues = {
    timetable: useSelector((state: RootState) => state?.models?.workPlace?.timetable),
  };

  const handleFieldChange = (changedValues: any, _allValues: any) => {
    for (const key in changedValues) {
      dispatch(updateField({ field: key, value: changedValues[key] }));
    }
  };

  return (
    <Form
      form={form}
      name='userForm'
      initialValues={initialValues}
      onValuesChange={handleFieldChange}
      layout='vertical'
      style={{ margin: '20px 20px' }}
    >
      <Row>
        <Col xs={24}>
          <Form.Item
            label='Descriere orar'
            name='timetable'
            rules={[{ required: true, message: 'Introdu descriere orar!' }]}
          >
            <TextArea placeholder='Ex: L-V: 8-10' />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default TimeTableTab;
